module.exports = __webpack_public_path__ + "img/jylnicon2.bb967f9d.jpg";